<template>
  <div class="friend-link">
    <div class="friend-link-wrapper">
      <div class="friend-link-bar clearfix">
        <span class="friend-link-title">友情链接</span>
      </div>
      <div class="friend-link-list">
        <a v-for="(item,index) in linkList" :key="index" :href="item.siteUrl" target="_blank">{{item.name}}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { home } from "../../request";
export default {
  mixins: [siteMixin],
  data() {
    return {
      linkList: []
    };
  },
  mounted() {
    this.getFooterLink();
  },
  methods: {
    getFooterLink() {
      if (this.siteConfig.agencyId === 0) return;
      home.getFooterLink(this.siteConfig.agencyId).then(result => {
        if (result.status === 1) {
          this.linkList = result.data;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.friend-link {
  width: 100%;
  .friend-link-wrapper {
    width: 1200px;
    margin: 0 auto;
    .friend-link-bar {
      padding: 20px 30px;
      border-bottom: 1px solid #ccc;

      .friend-link-title {
        font-size: 2.6rem;
        font-weight: bold;
        letter-spacing: 0.2rem;
      }
    }
    .friend-link-list {
      padding: 20px 0;
      a {
        display: inline-block;
        font-size: 1.6rem;
        padding: 5px 20px;
      }
    }
  }
}
</style>